import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaShoppingCart, FaMapMarkerAlt, FaArrowRight } from 'react-icons/fa';
import './FloatingOrderButton.css';

export default function FloatingOrderButton() {
  const [isVisible, setIsVisible] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Show button after a short delay
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const handleClick = () => {
    setIsAnimating(true);
    // Navigate to store selection page
    setTimeout(() => {
      navigate('/order/stores');
    }, 300);
  };

  return (
    <div className={`floating-order-container ${isVisible ? 'visible' : ''}`}>
      <button 
        className={`floating-order-btn ${isAnimating ? 'animating' : ''}`}
        onClick={handleClick}
        aria-label="Order Now - Find nearby stores"
      >
        <div className="btn-content">
          <div className="btn-icon">
            <FaShoppingCart />
          </div>
          <div className="btn-text">
            <span className="main-text">Order Now</span>
            <span className="sub-text">Find Nearby Stores</span>
          </div>
          <div className="btn-arrow">
            <FaArrowRight />
          </div>
        </div>
        
        {/* Floating elements */}
        <div className="floating-elements">
          <div className="float-element float-1">
            <FaMapMarkerAlt />
          </div>
          <div className="float-element float-2">
            <FaShoppingCart />
          </div>
          <div className="float-element float-3">
            <FaMapMarkerAlt />
          </div>
        </div>

        {/* Pulse effect */}
        <div className="pulse-ring"></div>
        <div className="pulse-ring delay-1"></div>
        <div className="pulse-ring delay-2"></div>
      </button>
    </div>
  );
}
